import { render, staticRenderFns } from "./BasicInfoBlock.vue?vue&type=template&id=4d4a761f&"
import script from "./BasicInfoBlock.vue?vue&type=script&lang=js&"
export * from "./BasicInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports